// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Fn-z","badgeLink":"Gn-z","category":"Hn-z"};